import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import Home from './home';
import UserPermission from './user/UserPermission';
import UserList from './user/UserList';
import Profile from './auth/Profile';
import Config from './config';
import ServiceList from './services/ServiceList';
import CustomerList from './customers/Index';
import CustomerClassList from './customer-class/CustomerClassList';
import CustomerStatusList from './customer-status/CustomerStatusList';
import CustomerInteractiveStatusList from './customer-interactive-status/CustomerInteractiveStatusList';
import CustomerInteractiveTypeList from './customer-interactive-type/CustomerInteractiveTypeList';
import PageManagerList from './page-manager/PageManagerList';
import messenger from './messenger';
import BranchList from './branch/BranchList';
import RoleGroup from './role-group/RoleGroupList';
import RoleList from './role/RoleList';
import ListDiseasesList from './list-diseases/ListDiseasesList';
import BloodTypeList from './blood-type/BloodTypeList';
import CustomerServicesList from './customer-services/CustomerServicesList';
import ProductList from './product/ProductList';
import VoucherList from './voucher/VoucherList';
import ProductGroupList from './product-group/ProductGroupList';
import ProductSupplierList from './product-supplier/ProductSupplierList';
import ProductWarehouseList from './product-warehouse/ProductWarehouseList';
import ProductReceiptImportList from './product-receipt-import/ProductReceiptImportList';
import CustomerSourceList from './customer-source/CustomerSourceList';
import PrivilegeError from './error/PrivilegeError';
import CustomerScheduleList from './customer-schedule/CustomerScheduleList';
import CustomerScheduleList2 from './customer-schedule/CustomerScheduleList2';
import ProductReceiptExportList from './product-receipt-export/ProductReceiptExportList';
import UnitList from './unit/UnitList';
import GuideList from './guide/GuideList';
import GuideDetail from './guide/GuideDetail';
import WorkReportList from './work-report/WorkReportList';
import TelegramList from './telegram/TelegramList';
import ProductStatusList from './product-status/ProductStatusList';
import LookupCustomerList from './lookup-customer/LookupCustomerList';
import CustomertTelesaleList from './customer-telesale/CustomerTelesaleList';
import CustomerConsultantDirectList from './customer-consultant-direct/CustomerConsultantDirectList';
import CustomerPotentialList from './customer-potential/CustomerPotentialList';
import CashReceiptList from './cash-receipt/CashReceiptList';
import PaymentVoucherList from './payment-voucher/PaymentVoucherList';
import RewardSpinList from './reward-spin/RewardSpinList';
import RewardSpinConfig from './reward-spin/RewardSpinConfig';
import RewardSpinCustomerHasList from './reward-spin/RewardSpinCustomerHasList';
import PostsList from './posts/PostsList';
import ViewPhonenumberList from './view-phonenumber/ViewPhonenumberList';
import ProjectList from './project/ProjectList';
import ProjectBasedJobList from './project-based-job/ProjectBasedJobList';
import JobsList from './jobs/JobsList';
import CashBookList from './cash-book/CashBookList';
import CardTypeList from './card-type/CardTypeList';
import CardReleaseTrackingList from './card-release-tracking/CardReleaseTrackingList';
import CardIssuedCountList from './card-issued-count/CardIssuedCountList';
import CardPendingCustomerList from './card-pending-customer/CardPendingCustomerList';
import CustomerData from './customer-data/CustomerData';
import RelationshipTypeList from './relationship-types/RelationshipTypeList';
import MediaList from './media/MediaList';
import { Typography } from 'antd';
import DocumentCategoriesList from './document-categories/DocumentCategoriesList';
import DocumentsList from './documents/DocumentsList';
import CustomerGroupList from './customer-group/CustomerGroupList';
import CommissionRuleList from '@/routes/commission-rule/CommissionRuleList';
import CommissionRevenueList from '@/routes/commission-revenue/CommissionRevenueList';
import CommissionList from '@/routes/commission/CommissionList';
import ZaloOAList from '@/routes/zalo-oa/ZaloOAList';
import RevenueReport from '@/routes/statistics/RevenueReport';
import AuditLogSearch from '@/routes/audit-logs/AuditLogSearch';
import LaboList from '@/routes/labos/LaboList';
import LaboCaseList from '@/routes/labo-cases/LaboCaseList';
import FeedbackRequestList from '@/routes/feedback-requests/FeedbackRequestList';
import FeedbackRequestDetail from '@/routes/feedback-requests/FeedbackRequestDetail';
import LaboStatistics from '@/routes/labo-cases/LaboStatistics';
import InventoryStats from './product/InventoryStats';
import Editor from './editor/Editor';
import FunctionalAreaList from './functional-area/FunctionalAreaList';
import FunctionalList from './functional/FunctionalList';
import ShiftSchedulingList from './shift-scheduling/ShiftSchedulingList';
import BranchFundList from './branch-funds/BranchFundList';
import PartnerAppointmentList from './partner-appointments/PartnerAppointmentList';
import PartnerTelesaleList from './partner-telesales/PartnerTelesaleList';
import PartnerCustomerList from './partner-customers/PartnerCustomerList';
import CustomerDetail from './customers/Detail/Index';
import MilestoneList from './cus-service-milestones/MilestoneList';
import InstructionTemplateList from './instruction-templates/InstructionTemplateList';
import ProcedureList from './procedures/ProcedureList';
import PrescriptionTemplateList from './prescription-templates/PrescriptionTemplateList';
import OrthodonticCustomerList from './customers/OrthodonticCustomerList';
import NotificationList from './notifications/NotificationList';
import StaffRevenueReport from './statistics/StaffRevenueReport';
import StaffRevenueYearly from './statistics/StaffRevenueYearly';
import CustomerCareCategoryList from './customer-care-categories/CustomerCareCategoryList';
import Monitoring from './monitoring/Monitoring';
import TelesaleFollowUpList from './telesale-follow-ups/TelesaleFollowUpList';
import AssistantsSupportCases from './statistics/AssistantsSupportCases';
import TreatmentSessionList from './treatment-sessions/TreatmentSessionList';
import CustomerVisits from './statistics/CustomerVisits';
import DoctorCustomerIndex from './doctor-customers/Index';
import DoctorAppointmentIndex from './doctor-appointments/Index';

const { Title } = Typography;


const ProtectedRoute = ({ authUser, permission, action = 'list', component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            if (!authUser) return <Redirect to="/login" />;

            // Admin luôn được quyền
            if (authUser.role_code === 'ADMIN') return <Component {...props} />;

            // Nếu không khai báo permission → luôn cho phép
            if (!permission) return <Component {...props} />;

            // Nếu có permission, mới kiểm tra action
            const userActions = authUser?.permissions?.[permission] || [];
            const actionList = action.split(',').map(a => a.trim());
            const hasPermission = actionList.some(act => userActions.includes(act));

            if (hasPermission) return <Component {...props} />;

            return (
                <div className="text-center mt-4">
                    <Title>Permission access is denied</Title>
                </div>
            );
        }}
    />
);

const routes = [
    {
        path: '/',
        component: Home,
        permission: null
    },
    {
        path: '/error/403',
        component: PrivilegeError,
        permission: null
    },
    {
        path: '/profile',
        component: Profile,
        permission: null
    },
    {
        path: '/users',
        component: UserList,
        permission: 'users',
        action: 'list'
    },
    {
        path: '/permissions',
        component: UserPermission,
        permission: 'permissions',
        action: 'list'
    },
    {
        path: '/config',
        component: Config,
        permission: 'config',
        action: 'update'
    },
    {
        path: '/service',
        component: ServiceList,
        permission: 'service',
        action: 'list'
    },
    {
        path: '/customers',
        component: CustomerList,
        permission: 'customer',
        action: 'list'
    },
    {
        path: '/customer-class',
        component: CustomerClassList,
        permission: 'customer_class',
        action: 'list'
    },
    {
        path: '/customer-status',
        component: CustomerStatusList,
        permission: 'customer_status',
        action: 'list'
    },
    {
        path: '/customer-interactive-status',
        component: CustomerInteractiveStatusList,
        permission: 'interaction_statuses',
        action: 'list'
    },
    {
        path: '/customer-interactive-type',
        component: CustomerInteractiveTypeList,
        permission: 'interaction_types',
        action: 'list'
    },
    {
        path: '/page-list',
        component: PageManagerList,
        permission: 'page_manager',
        action: 'list'
    },
    {
        path: '/messenger',
        component: messenger,
        permission: 'messenger',
        action: 'thread'
    },
    {
        path: '/branches',
        component: BranchList,
        permission: 'branch',
        action: 'list'
    },
    {
        path: '/role-group',
        component: RoleGroup,
        permission: 'role_group',
        action: 'list'
    },
    {
        path: '/roles',
        component: RoleList,
        permission: 'roles',
        action: 'list'
    },
    {
        path: '/list-diseases',
        component: ListDiseasesList,
        permission: 'diseases',
        action: 'list'
    },
    {
        path: '/blood-type',
        component: BloodTypeList,
        permission: 'blood_type',
        action: 'list'
    },
    {
        path: '/customer-services',
        component: CustomerServicesList,
        permission: 'customer_services',
        action: 'list'
    },
    {
        path: '/voucher-list',
        component: VoucherList,
        permission: 'voucher',
        action: 'list'
    },
    {
        path: '/product-list',
        component: ProductList,
        permission: 'product',
        action: 'list'
    },
    {
        path: '/product-statistics',
        component: InventoryStats,
        permission: 'product',
        action: 'statistics'
    },
    {
        path: '/product-group',
        component: ProductGroupList,
        permission: 'product_group',
        action: 'list'
    },
    {
        path: '/product-supplier',
        component: ProductSupplierList,
        permission: 'product_supplier',
        action: 'list'
    },
    {
        path: '/warehouse',
        component: ProductWarehouseList,
        permission: 'product_warehouse',
        action: 'list'
    },
    {
        path: '/receipt-import',
        component: ProductReceiptImportList,
        permission: 'product_receipt_import',
        action: 'list'
    },
    {
        path: '/receipt-export',
        component: ProductReceiptExportList,
        permission: 'product_receipt_export',
        action: 'list'
    },
    {
        path: '/customer-source',
        component: CustomerSourceList,
        permission: 'customer_source',
        action: 'list'
    },
    {
        path: '/customer-schedule',
        component: CustomerScheduleList,
        permission: 'customer_schedule',
        action: 'list'
    },
    {
        path: '/customer-schedule2',
        component: CustomerScheduleList2,
        permission: 'customer_schedule',
        action: 'list'
    },
    {
        path: '/unit',
        component: UnitList,
        permission: 'unit',
        action: 'list'
    },
    {
        path: '/guide',
        component: GuideList,
        permission: 'guide',
        action: 'list'
    },
    {
        path: '/guide/:id',
        component: GuideDetail,
        permission: 'guide',
        action: 'detail'
    },
    {
        path: '/work-report',
        component: WorkReportList,
        permission: 'work_report',
        action: 'list'
    },
    {
        path: '/telegram',
        component: TelegramList,
        permission: 'telegram',
        action: 'list'
    },
    {
        path: '/product-status',
        component: ProductStatusList,
        permission: 'product_status',
        action: 'list'
    },
    {
        path: '/lookup-customer',
        component: LookupCustomerList,
        permission: 'lookup_customer',
        action: 'list'
    },
    {
        path: '/customer-telesale',
        component: CustomertTelesaleList,
        permission: 'customer_telesale',
        action: 'list'
    },
    {
        path: '/customer-consultant-direct',
        component: CustomerConsultantDirectList,
        permission: 'customer_consultant_direct',
        action: 'list'
    },
    {
        path: '/customer-potential',
        component: CustomerPotentialList,
        permission: 'customer_potential',
        action: 'list'
    },
    {
        path: '/cash-receipt',
        component: CashReceiptList,
        permission: 'cash_receipt',
        action: 'list'
    },
    {
        path: '/payment-voucher',
        component: PaymentVoucherList,
        permission: 'payment_voucher',
        action: 'list'
    },
    {
        path: '/reward-histories',
        component: RewardSpinList,
        permission: 'reward_spin',
        action: 'list'
    },
    {
        path: '/reward-config',
        component: RewardSpinConfig,
        permission: 'reward_spin',
        action: 'config'
    },
    {
        path: '/reward-customer-has',
        component: RewardSpinCustomerHasList,
        permission: 'reward_spin',
        action: 'customer_has_list'
    },
    {
        path: '/posts',
        component: PostsList,
        permission: 'posts',
        action: 'list'
    },
    {
        path: '/view-phonenumber',
        component: ViewPhonenumberList,
        permission: 'view_phonenumber',
        action: 'list'
    },
    {
        path: '/project',
        component: ProjectList,
        permission: 'project',
        action: 'list'
    },
    {
        path: '/project-based-job',
        component: ProjectBasedJobList,
        permission: 'project_based_job',
        action: 'list'
    },
    {
        path: '/jobs',
        component: JobsList,
        permission: 'jobs',
        action: 'list'
    },
    {
        path: '/functional-area',
        component: FunctionalAreaList,
        permission: 'functional_area'
    },
    {
        path: '/functional',
        component: FunctionalList,
        permission: 'functional'
    },
    {
        path: '/jobs',
        component: JobsList,
        permission: 'jobs'
    },
    {
        path: '/shift-scheduling',
        component: ShiftSchedulingList,
        permission: 'shift_scheduling'
    },
    {
        path: '/audit-logs',
        component: AuditLogSearch,
        permission: 'audit_logs'
    },
    {
        path: '/cash-book',
        component: CashBookList,
        permission: 'cash_book',
        action: 'list'
    },
    {
        path: '/card-type',
        component: CardTypeList,
        permission: 'card_type',
        action: 'list'
    },
    {
        path: '/card-release-tracking',
        component: CardReleaseTrackingList,
        permission: 'card_release_tracking',
        action: 'list'
    },
    {
        path: '/card-issued-count',
        component: CardIssuedCountList,
        permission: 'card_issued_count',
        action: 'list'
    },
    {
        path: '/card-pending-customers',
        component: CardPendingCustomerList,
        permission: 'card_pending_customers',
        action: 'list'
    },
    {
        path: '/customer-data',
        component: CustomerData,
        permission: 'customer_data',
        action: 'lookup'
    },
    {
        path: '/relationship-types',
        component: RelationshipTypeList,
        permission: 'relationship_types',
        action: 'list'
    },
    {
        path: '/media',
        component: MediaList,
        permission: 'media',
        action: 'list'
    },
    {
        path: '/document-categories',
        component: DocumentCategoriesList,
        permission: 'document_categories',
        action: 'list'
    },
    {
        path: '/documents',
        component: DocumentsList,
        permission: 'documents',
        action: 'list'
    },
    {
        path: '/customer-group',
        component: CustomerGroupList,
        permission: 'customer_group',
        action: 'list'
    },
    {
        path: '/commission-rule',
        component: CommissionRuleList,
        permission: 'commission_rule',
        action: 'list'
    },
    {
        path: '/commission-revenue',
        component: CommissionRevenueList,
        permission: 'commission_revenue',
        action: 'list'
    },
    {
        path: '/commission',
        component: CommissionList,
        permission: 'commission',
        action: 'list'
    },
    {
        path: '/zalo-oa',
        component: ZaloOAList,
        permission: 'zalo',
        action: 'list'
    },
    {
        path: '/revenue-report',
        component: RevenueReport,
        permission: 'statistics',
        action: 'revenue'
    },
    {
        path: '/labos',
        component: LaboList,
        permission: 'labos',
        action: 'list'
    },
    {
        path: '/labo-cases',
        component: LaboCaseList,
        permission: 'labo_cases',
        action: 'list'
    },
    {
        path: '/labo-statistics',
        component: LaboStatistics,
        permission: 'labo_cases',
        action: 'status_statistics, customer_statistics'
    },
    {
        path: '/feedback-requests',
        component: FeedbackRequestList,
        permission: 'feedback_requests',
        action: 'list'
    },
    {
        path: '/feedback-requests/:id',
        component: FeedbackRequestDetail,
        permission: 'feedback_requests',
        action: 'detail'
    },
    {
        path: '/editor',
        component: Editor,
        permission: null
    },
    {
        path: '/branch-funds',
        component: BranchFundList,
        permission: 'branch_fund',
        action: 'list'
    },
    {
        path: '/partner-appointments',
        component: PartnerAppointmentList,
        permission: 'partner_appointments',
        action: 'list'
    },
    {
        path: '/partner-telesales',
        component: PartnerTelesaleList,
        permission: 'partner_telesales',
        action: 'list'
    },
    {
        path: '/partner-customers',
        component: PartnerCustomerList,
        permission: 'partner_customers',
        action: 'list'
    },
    {
        path: '/procedures',
        component: ProcedureList,
        permission: 'procedures',
        action: 'list'
    },
    {
        path: '/instruction-templates',
        component: InstructionTemplateList,
        permission: 'instruction_templates',
        action: 'list'
    },
    {
        path: '/prescription-templates',
        component: PrescriptionTemplateList,
        permission: 'prescription_templates',
        action: 'list'
    },
    {
        path: '/customer/:id',
        component: CustomerDetail,
        permission: 'customer',
        action: 'detail'
    },
    {
        path: '/milestone-invisalign',
        component: MilestoneList,
        permission: 'milestones',
        action: 'list'
    },
    {
        path: '/orthodontic-customer',
        component: OrthodonticCustomerList,
        permission: 'customer',
        action: 'orthodontic_customer'
    },
    {
        path: '/notifications',
        component: NotificationList,
        permission: null,
        action: 'list'
    },
    {
        path: '/staff-revenue-report',
        component: StaffRevenueReport,
        permission: 'statistics',
        action: 'staff_revenue_detail'
    },
    {
        path: '/staff-revenue-yearly',
        component: StaffRevenueYearly,
        permission: 'statistics',
        action: 'staff_revenue_detail'
    },
    {
        path: '/customer-care-categories',
        component: CustomerCareCategoryList,
        permission: 'customer_care_categories',
        action: 'list'
    },
    {
        path: '/monitoring',
        component: Monitoring,
        permission: 'monitorings',
        action: 'view'
    },
    {
        path: '/telesale-follow-ups',
        component: TelesaleFollowUpList,
        permission: 'telesale_follow_up',
        action: 'list'
    },
    {
        path: '/assistants-support-cases',
        component: AssistantsSupportCases,
        permission: 'statistics',
        action: 'assistants_support_cases'
    },
    {
        path: '/treatment-sessions',
        component: TreatmentSessionList,
        permission: 'treatment_sessions',
        action: 'list'
    },
    {
        path: '/customer-visits',
        component: CustomerVisits,
        permission: 'statistics',
        action: 'customer_visits'
    },
    {
        path: '/doctor-customers',
        component: DoctorCustomerIndex,
        permission: 'doctor_customers',
        action: 'list'
    },
    {
        path: '/doctor-appointments',
        component: DoctorAppointmentIndex,
        permission: 'doctor_appointments',
        action: 'list'
    }
];

class Routes extends Component {

    render() {
        var { authUser } = this.props;

        return (
            <Switch>
                {routes.map((route, index) => (
                    <ProtectedRoute
                        key={index}
                        exact
                        path={route.path}
                        authUser={authUser}
                        permission={route.permission}
                        action={route.action || 'list'}
                        component={route.component}
                    />
                ))}
            </Switch>
        )
    }
}

function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser
    }
}

export default connect(mapStateToProps, null)(Routes);

